// extracted by mini-css-extract-plugin
export default {"invoiceAddress":"InvoiceAddress_invoiceAddress__GNVxs","addressCopy":"InvoiceAddress_addressCopy__-Pbqc","show":"InvoiceAddress_show__sGxAO"};